import React from "react";
import { Img } from "@/components/image";
import type { MediaType } from "@/types/media.type";

type AvatarType = MediaType;

export const MultiDietDoubtsAvatar = ({
  avatar,
  url,
}: {
  avatar: AvatarType;
  url: string;
}) => {
  return (
    <div className="relative h-[48px] w-[48px] rounded-full border-1 border-brand-grey2 p-[0.10em] lg:h-[88px] lg:w-[88px] lg:p-1">
      <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-[#C6ABE5] p-1 lg:p-2">
        <Img
          src={url}
          alt={avatar.name}
          width={avatar.width ?? 0}
          height={avatar.height ?? 0}
        />
      </div>
      <div className="absolute right-0 bottom-[10%] h-[12px] w-[12px] rounded-full border-2 border-brand-white bg-brand-green-300 lg:h-[20px] lg:w-[20px]" />
    </div>
  );
};
